import Hero from "./home/Hero";
import Marquee from "./home/Marquee";
import Services from "./home/Services";
import Pricing from "./home/Pricing";
import Features from "./home/Features";
import HowItWorks from "./home/HowItWorks";
import WhyHub from "./home/WhyHub";
import Devices from "./home/Devices";
import Testimonials from "./home/Testimonials";
import Faq from "./home/Faq";
import Contact from "./home/Contact";
import CtaBand from "./home/CtaBand";

export default function Home() {
  return (
    <main id="top">
      <Hero />
      <Marquee />
      <Services />
      <Pricing />
      <Features />
      <HowItWorks />
      <WhyHub />
      <Devices />
      <Testimonials />
      <Faq />
      <Contact />
      <CtaBand />
    </main>
  );
}
